export const enum ElementIds {
  RootElement = 'dashworksRoot',
  TextEditorToolbar = 'textEditorToolbar',
  OpenIntercomButton = 'OpenIntercomButton',
  CaptchaUIContainer = 'captcha',
}
